import { NegotiationState } from '../../../generated/graphql';
import { GetSpaceBase } from '../../types/GetSpaceBase';
import { getUndefinedSpace } from '../../utils/getUndefinedSpace';
import { spaceFactory } from '../../utils/spaceFactory';

export const getSpaceClaro: GetSpaceBase = (group, space, context) => {
  const { negBooleans } = context;
  const {
    isClaro,
    isPaymentPromise,
    negState,
  } = negBooleans!;

  switch (group) {
    case 'NEG_OPTION': {
      switch (space) {
        case 'description': {
          if (isClaro && isPaymentPromise) {
            return spaceFactory('NEG_OPTION.description.paymentPromise').get();
          }
          break;
        }
        case 'state.alert': {
          if (isClaro && isPaymentPromise) {
            if (negState === NegotiationState.ConfirmedByUser) {
              return spaceFactory('NEG_OPTION.state.alert.claro.paymentPromise').get();
            }
            if (negState === NegotiationState.PrepaymentCompleted) {
              return spaceFactory('NEG_OPTION.state.alert.PrepaymentCompleted.paymentPromise').get();
            }
            if (negState === NegotiationState.SentToBank) {
              return spaceFactory('NEG_OPTION.state.alert.sentToBank.paymentPromise').get();
            }
            return spaceFactory('NEG_OPTION.state.alert.paymentPromise').get();
          }

          break;
        }
        case 'title': {
          if (isClaro && isPaymentPromise) {
            return spaceFactory('NEG_OPTION.title.paymentPromise').get();
          }
          break;
        }
        default: break;
      }
      break;
    }
    case 'NEG_OPTION_CONDITIONS': {
      switch (space) {
        case 'benefits.text': {
          if (isClaro && isPaymentPromise) {
            return spaceFactory('NEG_OPTION_CONDITIONS.benefits.paymentPromise').get();
          }
          break;
        }
        case 'consequences.text': {
          if (isClaro && isPaymentPromise) {
            return spaceFactory('NEG_OPTION_CONDITIONS.consequences.paymentPromise').get();
          }
          break;
        }
        default: break;
      }
      break;
    }
    case 'NEG_OPTION_SUMMARY': {
      switch (space) {
        case 'alert.conditions': {
          if (isClaro && isPaymentPromise) {
            return spaceFactory('NEG_OPTION_SUMMARY.alert.conditions.paymentPromise').get();
          }
          break;
        }
        case 'alert': {
          if (isClaro && isPaymentPromise) {
            return spaceFactory('NEG_OPTION_SUMMARY.alert.paymentPromise').get();
          }
          break;
        }
        case 'description': {
          if (isClaro && isPaymentPromise) {
            return spaceFactory('NEG_OPTION_SUMMARY.description.paymentPromise').get();
          }
          break;
        }
        default: break;
      }
      break;
    }
    case 'NEG_CONFIRMATION': {
      switch (space) {
        case 'alert': {
          if (isClaro && isPaymentPromise) {
            return spaceFactory('NEG_CONFIRMATION.payment.alert.paymentPromise').get();
          }
          if (isClaro && isPaymentPromise) {
            return spaceFactory('NEG_CONFIRMATION.alert.paymentPromise').get();
          }
          break;
        }
        default: break;
      }
      break;
    }

    default: break;
  }

  return getUndefinedSpace();
};
